import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Webhook } from "lucide-react";

export const LoomySection = ({ settings, onInputChange }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Webhook className="w-5 h-5" />
        Intégrations
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="loomy_brand_api_key">Loomy Brand API Key</Label>
        <Input
          id="loomy_brand_api_key"
          type="password"
          value={settings.loomy_brand_api_key}
          onChange={(e) => onInputChange("loomy_brand_api_key", e.target.value)}
          placeholder="Votre cle API Loomy Brand"
        />
        <p className="text-xs text-muted-foreground">Trouvez votre cle API dans : Loomy CRM → Marque → API</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="whatsapp_number">Numéro WhatsApp</Label>
        <Input
          id="whatsapp_number"
          value={settings.whatsapp_number || ""}
          onChange={(e) => onInputChange("whatsapp_number", e.target.value)}
          placeholder="+41 79 123 45 67"
        />
        <p className="text-xs text-muted-foreground">Le bouton WhatsApp flottant s'affiche uniquement si un numéro est renseigné.</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="loomy_rdv_url">Lien prise de RDV (Loomy)</Label>
        <Input
          id="loomy_rdv_url"
          value={settings.loomy_rdv_url || ""}
          onChange={(e) => onInputChange("loomy_rdv_url", e.target.value)}
          placeholder="https://app.loomy-crm.com/rdv/..."
        />
        <p className="text-xs text-muted-foreground">Affiché dans les résultats du diagnostic. Laissez vide pour masquer.</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="webhook_url">Webhook notifications (Slack/Teams/Discord)</Label>
        <Input
          id="webhook_url"
          value={settings.webhook_url || ""}
          onChange={(e) => onInputChange("webhook_url", e.target.value)}
          placeholder="https://hooks.slack.com/services/..."
        />
        <p className="text-xs text-muted-foreground">Reçoit une notification à chaque diagnostic complété. Compatible Slack, Teams, Discord.</p>
      </div>
    </CardContent>
  </Card>
);
